import ALDuration from "@/views/em/analytics-log/ALDuration.vue";
import ALUserInteraction from "@/views/em/analytics-log/ALUserInteraction.vue";

export default [
    {
        path: '/em/al/duration',
        component: ALDuration
    },
    {
        path: '/em/al/userInteraction',
        component: ALUserInteraction
    }
]
